"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
exports.SearchFieldBox = styled_components_1.default.div `
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
`;
//# sourceMappingURL=search-field-box.js.map